import { cn } from '@worldcoo/ui/lib/utils';
import { cva } from 'class-variance-authority';

const gradientVariants = cva(
	'pointer-events-none bottom-0 left-0 right-0 w-full h-[142px] bg-gradient-to-b from-transparent',
	{
		variants: {
			variant: {
				default: 'via-background via-62% to-background',
				hero: 'via-accent via-62% to-accent',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	},
);

export function Gradient(props: { className?: string; variant?: 'default' | 'hero' }) {
	return <div className={cn(gradientVariants({ variant: props.variant }), props.className)} />;
}
